module.exports = __webpack_public_path__ + "b2712024f6fa073b2e82bfed2e348aed.pdf";